// extracted by mini-css-extract-plugin
export default {"modalWrapper":"WorkflowPreview_modalWrapper__PMCH2","flow":"WorkflowPreview_flow__DlIiN"};